// extracted by mini-css-extract-plugin
var _1 = "CommentTimestamp-module__animateUploadProgressBarWidth--bHYeo";
var _2 = "CommentTimestamp-module__animatedBackground--WIwK4";
var _3 = "CommentTimestamp-module__labels--FEM27";
var _4 = "CommentTimestamp-module__timestamp--aEUJa";
var _5 = "CommentTimestamp-module__timestampButton--LMe7i";
var _6 = "CommentTimestamp-module__timestamps--ZDLyA";
var _7 = "CommentTimestamp-module__tooltip--xMEqz";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "labels", _4 as "timestamp", _5 as "timestampButton", _6 as "timestamps", _7 as "tooltip" }
